import { render, staticRenderFns } from "./CompanyTemplates.vue?vue&type=template&id=191953e4&scoped=true&"
import script from "./CompanyTemplates.vue?vue&type=script&lang=js&"
export * from "./CompanyTemplates.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTemplates.vue?vue&type=style&index=0&id=191953e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191953e4",
  null
  
)

export default component.exports